import LinkToDocusaurus from '../LinkToDocusaurus'
import { testCases } from '../../docs-routes'

const LinkToTestCasesDoc = () =>
  <LinkToDocusaurus path={testCases}>
    Learn more about Test Cases
  </LinkToDocusaurus>

export default LinkToTestCasesDoc
